<template>
  <div class="params-config">
    <el-tabs type="border-card">
      <el-tab-pane :label="$t('app.accommodationParameterConfiguration')">
        <accommodation-params :childrenData="info"></accommodation-params>
      </el-tab-pane>
      <el-tab-pane :label="$t('app.mailParameterConfiguration')">
        <mail-params :childrenData="info"></mail-params>
      </el-tab-pane>
      <el-tab-pane label="門禁參數配置">
        <overnight-params :childrenData="info"></overnight-params>
      </el-tab-pane>
      <el-tab-pane label="系統參數配置">
        <system-params :childrenData="info"></system-params>
      </el-tab-pane>
      <el-tab-pane label="接载服务配置">
        <pick-up-params :childrenData="info"></pick-up-params>
      </el-tab-pane>
      <el-tab-pane label="RMS參數配置">
        <rms-params ref="rmsModal" :childrenData="info"></rms-params>
      </el-tab-pane>
      <el-tab-pane label="访客住宿參數配置">
        <guest-params ref="guestModal" :childrenData="info"></guest-params>
      </el-tab-pane>
    </el-tabs>
    <el-button
      size="small"
      style="margin-top: 20px"
      type="primary"
      @click="submit"
      >{{ $t("app.submit") }}</el-button
    >
  </div>
</template>
<script>
import AccommodationParams from "./modules/AccommodationParams";
import GuestParams from "./modules/GuestParams";
import MailParams from "./modules/MailParams";
import OvernightParams from "./modules/OvernightParams";
import SystemParams from "./modules/SystemParams";
import PickUpParams from "./modules/PickUpParams";
import RmsParams from "./modules/RmsParams";
import { getData, saveData } from "@/api/systemManagement/paramsConfig";
export default {
  components: {
    GuestParams,
    AccommodationParams,
    MailParams,
    OvernightParams,
    SystemParams,
    PickUpParams,
    RmsParams,
  },
  data() {
    return {
      info: {
        oldStuStartDate: "",
        oldStuEndDate: "",
        newStuStartDate: "",
        newStuEndDate: "",
        username: "",
        userAddress: "",
        password: "",
        dateFirst: "",
        dateSecond: "",
        emailHost: "",
        emailHostPort: "",
        needAuthenticate: false,
        laterDate: "",
        outerDate: "",
        doorAIn: "",
        doorAOut: "",
        doorBIn: "",
        doorBOut: "",
        specialTimeA: "",
        specialTimeB: "",
        apiAddr: "",
        BatchNoRuleSplitChar: "",
        BatchNoRule: "",
        InternalRemark: "",
        ExternalRemark: "",
        StartDate: "",
        EndDate: "",
        HostelDeadlineDate: "",
        BatchNoRuleDetail: [],
        firstSemesterBeginDate: "",
        secondSemesterBeginDate: "",
        BookingNumberPrefix: "",
        BookingNumberLength: "",
        BookingNumberInitialization: "",
        InvoiceNumberInitialization: "",
        schoolYear: '',
        semester: '',
      },
    };
  },
  created() {
    getData().then((res) => {
      this.info.schoolYear = this.valueOrEmpty(
        res.data.SchoolYear
      );
      this.info.semester = this.valueOrEmpty(
        res.data.Semester
      );
      this.info.oldStuStartDate = this.valueOrEmpty(
        res.data.OldStudentApplicationStartDate
      );
      this.info.oldStuEndDate = this.valueOrEmpty(
        res.data.OldStudentApplicationEndDate
      );
      this.info.newStuStartDate = this.valueOrEmpty(
        res.data.NewStudentApplicationStartDate
      );
      this.info.newStuEndDate = this.valueOrEmpty(
        res.data.NewStudentApplicationEndDate
      );
      this.info.dateFirst = this.valueOrEmpty(
        res.data.FirstSemesterCheckOutDate
      );
      this.info.dateSecond = this.valueOrEmpty(
        res.data.SecondSemesterCheckOutDate
      );
      this.info.mailServe = this.valueOrEmpty(
        res.data.SupportPickUpServiceDate
      );
      this.info.mailServeTime = this.valueOrEmpty(
        res.data.SupportPickUpServiceTime
      );
      this.info.emailHost = this.valueOrEmpty(res.data.EmailHost);
      this.info.emailHostPort = this.valueOrEmpty(res.data.EmailHostPort);
      this.info.needAuthenticate =
        this.valueOrEmpty(res.data.NeedAuthenticate) == "true" ? true : false;
      this.info.username = this.valueOrEmpty(res.data.CredentialUserName);
      this.info.password = this.valueOrEmpty(res.data.CredentialUserPwd);
      this.info.userAddress = this.valueOrEmpty(res.data.CredentialUserAddress);
      this.info.laterDate = this.valueOrEmpty(res.data.LaterTime);
      this.info.outerDate = this.valueOrEmpty(res.data.OuterTime);
      this.info.doorAIn = this.valueOrEmpty(res.data.DoorAInnerId);
      this.info.doorAOut = this.valueOrEmpty(res.data.DoorAOuterId);
      this.info.doorBIn = this.valueOrEmpty(res.data.DoorBInnerId);
      this.info.doorBOut = this.valueOrEmpty(res.data.DoorBOuterId);
      this.info.specialTimeA = this.valueOrEmpty(
        res.data.SpecialLaterTimeGroup
      );
      this.info.specialTimeB = this.valueOrEmpty(
        res.data.SpecialOuterTimeGroup
      );
      this.info.apiAddr = this.valueOrEmpty(res.data.ApiAddress);
      this.info.BatchNoRuleSplitChar = this.valueOrEmpty(
        res.data.BatchNoRuleSplitChar
      );
      this.info.BatchNoRule = this.valueOrEmpty(res.data.BatchNoRule);
      this.info.InternalRemark = this.valueOrEmpty(res.data.InternalRemark);
      this.info.ExternalRemark = this.valueOrEmpty(res.data.ExternalRemark);
      this.info.StartDate = this.valueOrEmpty(res.data.StartDate);
      this.info.EndDate = this.valueOrEmpty(res.data.EndDate);
      this.info.HostelDeadlineDate = this.valueOrEmpty(
        res.data.HostelDeadlineDate
      );
      this.info.BatchNoRuleDetail = res.data.BatchNoRuleDetail || [];
      this.info.firstSemesterBeginDate = this.valueOrEmpty(
        res.data.FirstSemesterBeginDate
      );
      this.info.secondSemesterBeginDate = this.valueOrEmpty(
        res.data.SecondSemesterBeginDate
      );
      this.info.BookingNumberPrefix = res.data.BookingNumberPrefix || "EAHR";
      this.info.BookingNumberLength = res.data.BookingNumberLength || "6";
      this.info.BookingNumberInitialization =
        res.data.BookingNumberInitialization || "000001";
      this.info.InvoiceNumberInitialization =
        res.data.InvoiceNumberInitialization || "10000";
      this.$refs.rmsModal.init(this.info.BatchNoRuleDetail);
    });
  },
  methods: {
    submit() {
      saveData({
        Semester: this.info.semester,
        SchoolYear: this.info.schoolYear,
        NewStudentApplicationStartDate: this.info.newStuStartDate,
        NewStudentApplicationEndDate: this.info.newStuEndDate,
        OldStudentApplicationStartDate: this.info.oldStuStartDate,
        OldStudentApplicationEndDate: this.info.oldStuEndDate,
        FirstSemesterCheckOutDate: this.info.dateFirst,
        SecondSemesterCheckOutDate: this.info.dateSecond,
        SupportPickUpServiceDate: this.info.mailServe,
        SupportPickUpServiceTime: this.info.mailServeTime,
        CredentialUserName: this.info.username,
        CredentialUserAddress: this.info.userAddress,
        CredentialUserPwd: this.info.password,
        EmailHost: this.info.emailHost,
        EmailHostPort: this.info.emailHostPort,
        NeedAuthenticate: this.info.needAuthenticate,
        LaterTime: this.info.laterDate,
        OuterTime: this.info.outerDate,
        DoorAInnerId: this.info.doorAIn,
        DoorAOuterId: this.info.doorAOut,
        DoorBInnerId: this.info.doorBIn,
        DoorBOuterId: this.info.doorBOut,
        SpecialLaterTimeGroup: this.info.specialTimeA,
        SpecialOuterTimeGroup: this.info.specialTimeB,
        ApiAddress: this.info.apiAddr,
        BatchNoRuleSplitChar: this.info.BatchNoRuleSplitChar,
        BatchNoRule: this.info.BatchNoRule,
        InternalRemark: this.info.InternalRemark,
        ExternalRemark: this.info.ExternalRemark,
        StartDate: this.info.StartDate,
        EndDate: this.info.EndDate,
        HostelDeadlineDate: this.info.HostelDeadlineDate,
        BatchNoRuleDetail: this.info.BatchNoRuleDetail,
        FirstSemesterBeginDate: this.info.firstSemesterBeginDate,
        SecondSemesterBeginDate: this.info.secondSemesterBeginDate,
        BookingNumberPrefix: this.info.BookingNumberPrefix,
        BookingNumberLength: this.info.BookingNumberLength,
        BookingNumberInitialization: this.info.BookingNumberInitialization,
        InvoiceNumberInitialization: this.info.InvoiceNumberInitialization,
      }).then(() => {
        this.$message({
          message: this.$t("app.opeSuccess"),
          type: "success",
        });
      });
    },
    valueOrEmpty(value) {
      return value || "";
    },
  },
};
</script>
